// extracted by mini-css-extract-plugin
export default {"cardShineFirstLayer":"CardShine_cardShineFirstLayer__NfMc8","cardShineSecondLayer":"CardShine_cardShineSecondLayer__O6Pzu"};